import type { Errors } from '@inertiajs/core';

// `errorValueType` is declared as `string[]` app-wide (a model's `errors` yields arrays),
// but the apply flow's controllers ship one message per key — the string the server
// action used to return and the form toasts.
export function errorMessages(errors: Errors) {
  return errors as unknown as Record<string, string | undefined>;
}
